var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8415 9.65008L10.3415 2.15008C10.0415 1.85008 9.62484 1.66675 9.1665 1.66675H3.33317C2.4165 1.66675 1.6665 2.41675 1.6665 3.33341V9.16675C1.6665 9.62508 1.84984 10.0417 2.15817 10.3501L9.65817 17.8501C9.95817 18.1501 10.3748 18.3334 10.8332 18.3334C11.2915 18.3334 11.7082 18.1501 12.0082 17.8417L17.8415 12.0084C18.1498 11.7084 18.3332 11.2917 18.3332 10.8334C18.3332 10.3751 18.1415 9.95008 17.8415 9.65008ZM10.8332 16.6751L3.33317 9.16675V3.33341H9.1665V3.32508L16.6665 10.8251L10.8332 16.6751Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4165 6.66675C6.10686 6.66675 6.6665 6.1071 6.6665 5.41675C6.6665 4.72639 6.10686 4.16675 5.4165 4.16675C4.72615 4.16675 4.1665 4.72639 4.1665 5.41675C4.1665 6.1071 4.72615 6.66675 5.4165 6.66675Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalOffer);
export default __webpack_public_path__ + "static/media/local_offer.05eaab7eb1ea65bfbe0674a927982113.svg";
export { ForwardRef as ReactComponent };